<div class="order-success-sec" *ngIf="createOrder">
    <img src="{{successIcon}}" alt="">
    <!-- <span class="close-button" (click)="closePopup()">✖</span> -->
    <h3>Order Created!</h3>
    <p class="order-label">Order ID <span class="order-id">#{{order.orderNumber}}</span></p>
    <!-- <p class="date-text"><span>{{order.orderDate | date: 'MMM dd yyyy hh:mm a'}}</span></p> -->
    <p class="date-text">{{order.orderDate}}</p>

    <button class="goto-order" (click)="goToOrder()">Track My Order</button>
</div>
<div *ngIf="magicOrder" class="success-popup-overlay">
  <div class="success-popup">
    <div class="success-icon"><img src="{{successIcon}}" alt=""></div>
    <h2>Order Created Successfully! 🎉</h2>
    <p class="order-number">Order No. {{order.orderNumber}}</p>
    <p class="order-date">{{order.orderDate}}</p>

    <div class="info-box" *ngIf="missingArray.length>0">
      <i>watch_later</i>
      <div>
      <p style="margin-bottom: 0;"><strong>We're still sourcing the best prices for:</strong></p>
        <div class="scroll">
      <ul *ngFor="let item of missingArray">
        <li>{{item}}</li>
      </ul>
    </div>
      <div>
        A request has been created for the remaining items.<br />
        🔍 <strong>Request ID: {{requestId}}</strong><br />
        <p class="track-page">
        You can track it in the "My Requests" page.
        </p>
      </div>
      </div>
    </div>

    <button class="track-btn" (click)="goToOrder()">🎁 TRACK YOUR ORDER</button>
    <a class="my-requests-link" (click)="requestSuccessPopup()"  *ngIf="missingArray.length>0">Go to My Requests</a>
  </div>
</div>
